<template>
  <div class="container_box">

     <div  class="appstyle">
        <div  class="window-first">外卖神券</div>
        <div  class="app-first"> 美团外卖神券，每日必得22元外卖红包 </div>
        <div  class="app-icon2s">
          <img src="https://blog.huangque888.com/xcx.jpg" alt="美团外卖神券，每日必得22元外卖红包" >
          <div  class="app-title8" style="text-align:center;">微信扫码打开小程序</div>
        </div>
     </div>

     <div  class="appstyle">
        <div  class="window-first">公众号</div>
        <div  class="app-first"> 关注公众号，每日红包不错过 </div>
        <div  class="app-icon2s">
          <img src="https://blog.huangque888.com/qr.png" alt="微信扫码关注" >
          <div  class="app-title8" style="text-align:center;">微信扫码关注</div>
        </div>
     </div>

   
    
  </div>
</template>


<script>
export default {
  data(){
    return{
      activeIndex:"6",
      header:{"token":this.$store.getters.getToken}

    }
  },
  mounted() {
      this.$store.commit("setActiveIndex",this.activeIndex);
      this.load();
  },
  computed: {
    noMore () {
      return this.count.length == 0
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    
   
  }
  
}


</script>
